import React from "react";
import styled from "styled-components";
import { Card } from "primereact/card";

const MyMenu = styled(Card)`
  .p-card {
    background: white;
    box-shadow: 0px 3px 6px #00000029;
  }
  .p-card-body {
    padding: 0.5rem;
  }
  .p-card-content {
    color: #595b5f;
    padding: 0.5rem !important;
  }
`;

const MenuItem = styled.a`
  text-decoration:none;
  padding: 0.8rem;
  cursor: pointer;
  &:link,&:visited,&:active{
    color:inherit
  }
`;

const LinkStyled = styled.span`
  a {
    text-decoration:none;
    padding: 0.8rem;
    cursor: pointer;
    &:link,&:visited,&:active{
      color:inherit
    }
  }
`;

export interface MenuProps {
  items: Array<any>;
  LinkNavigate: any;
}

const continueRender = (entry: any) => (
  <>
    <img
      src={entry.icon}
      alt="icon"
      style={{ width: entry.width, marginRight: "1.2rem" }}
    />
    {entry.label}
  </>
);

const Menu: React.FC<MenuProps> = ({ items, LinkNavigate }) => (
  <MyMenu style={{ borderRadius: "10px", height: "3rem" }}>
    {items &&
      items.map((entry: any, index: number) => {
        return entry.url.includes('https')
          ? (<MenuItem href={entry.url} key={index}>{continueRender(entry)}</MenuItem>)
          : (<LinkStyled><LinkNavigate to={entry.url}>{continueRender(entry)}</LinkNavigate></LinkStyled>);
      })}
  </MyMenu >
);

export default Menu;
